import { Component, Input, OnInit } from '@angular/core';
import { UserInfoStateStructure, LOGIN_INFO_REDUCER_NAME, LINE_OF_BUSINESS_ENUM, EntitlementsHelperService, USER_ROLE, ENTITLEMENTS, BaseAgency } from '@ptl/account-management';
import { ReducerUtilityService } from 'src/app/shared/utility-services/reducer-utility.service';
import { ContentStorageService, PtlWindowLocationService } from '@ptl/global-components';
import { BrandingConfigurationService } from '@ptl/brand';
import { CookieService } from 'ngx-cookie-service';
import { ProducerAgencyHelperService } from '../../producer-agency-helper.service';
import { AuthoringModeService } from 'src/app/shared/services/authoring-mode.service';
import { PortalLinkService } from '../portal-link.service';

@Component({
    selector: 'app-plan-advisor-sso',
    templateUrl: './plan-advisor-sso.component.html',
    styleUrls: ['./plan-advisor-sso.component.scss'],
    standalone: false
})
export class PlanAdvisorSsoComponent implements OnInit {

  @Input() planAdvisorLabel: string;
  @Input() isRenewal: boolean;
  @Input() customData?: string;


  planAdvisorRenewalSSOUrl: string;
  planAdvisorNewToBlueSSOUrl: string;

  userHasAccess = false;

  loginData: UserInfoStateStructure;
  lob: LINE_OF_BUSINESS_ENUM;

  agencyModernizationPilot: boolean; // false means show

  constructor(
    private reducerUtilityService: ReducerUtilityService,
    private contentService: ContentStorageService,
    private brandService: BrandingConfigurationService,
    private cookieService: CookieService,
    private agencyHelper: ProducerAgencyHelperService,
    private entitlementService: EntitlementsHelperService,
    private authoringMode: AuthoringModeService,
    private portalLinkService: PortalLinkService,
  ) { }

  async ngOnInit() {
    this.lob = await this.entitlementService.getCurrentLobPromise();
    this.loginData = this.reducerUtilityService.getReducerFromApplicationState(LOGIN_INFO_REDUCER_NAME);


    const selectedAgency: BaseAgency = (
      this.loginData &&
      this.loginData.userInfo &&
      this.loginData.userInfo.agencyInfo &&
      this.loginData.userInfo.agencyInfo.selectedAgencies &&
      this.loginData.userInfo.agencyInfo.selectedAgencies[this.lob]
    );

    const isAuthoringMode = this.authoringMode.getAuthoringMode();
    this.agencyModernizationPilot = this.checkAgencyAccessList(selectedAgency);
    // TODO: agencyModernizationPilot is temporary during Plan Advisor modernization, remove this logic after full production GOLIVE.

    const hasEntitlement = isAuthoringMode || this.hasEntitlementCheck(selectedAgency); 
    
    if (hasEntitlement
      && selectedAgency
      && this.agencyIdentifierExists(selectedAgency)
      && this.agencyModernizationPilot) {

        this.userHasAccess = true;

        if (this.brandService.isNonHmBrand()) {
          this.createPlanAdvisorSSOsNonHM();
        } else {
          this.createPlanAdvisorSSOsHM();
        }
      } else {
        this.userHasAccess = false;
      }

    }

    /**
     * 1) Entitlement must be active
     * 2) Agency must be selected
     * 3) Agency must have an ID
     * 4) If Agency is in Modernization Pilot list, then user shouldn't have access to legacy button.
     */

  hasEntitlementCheck(selectedAgency){
    const selectedAgencyEntitlements = this.getEntitlementsByUserType(selectedAgency);

    if (this.isRenewal) {
      if (selectedAgencyEntitlements) {
        for (const entitlement of selectedAgencyEntitlements) {
          if (entitlement.descriptionKey === ENTITLEMENTS.RENEWALS) {
            if (entitlement.hasEntitlement === true) {
              return true;
            }
          }
        }
      }
    } else {
      if (selectedAgencyEntitlements) {
        for (const entitlement of selectedAgencyEntitlements) {
          if (entitlement.descriptionKey === ENTITLEMENTS.SMALL_GRP_QUOTES) {
            if (entitlement.hasEntitlement === true) {
              return true;
            }
          }
        }
      }
    }
    return false;
  }

  getEntitlementsByUserType(selectedAgency){
    const isInternalUser = this.loginData.basicUserInfo.userType.toLocaleLowerCase() === USER_ROLE.INTERNAL.toLowerCase();

    if (isInternalUser) {
      switch (this.lob) {
        case LINE_OF_BUSINESS_ENUM.INDIVIDUAL: return (
          this.loginData.userInfo.broker360ACAAgencies &&
          this.loginData.userInfo.broker360ACAAgencies[0].entitlements
        );
        case LINE_OF_BUSINESS_ENUM.SENIOR: return (
          this.loginData.userInfo.broker360Agencies &&
          this.loginData.userInfo.broker360Agencies[0].entitlements
        );
        case LINE_OF_BUSINESS_ENUM.SMALL_GROUP: return (
          this.loginData.userInfo.agencies &&
          this.loginData.userInfo.agencies[0].entitlements
        );
      }
    } else {
      return selectedAgency.entitlements;
    }
  }

  createPlanAdvisorSSOsHM() {
    const userInfo = this.loginData.userInfo;
    const selectedAgency = userInfo.agencyInfo.selectedAgencies[this.lob];

    const login_ID = this.loginData.userId;
    const region = selectedAgency.region;
    const agency_ID = this.agencyHelper.padAgencyId(selectedAgency.agencyId);

    //let telesalesEntitlement = this.agencyHelper.hasEntitlement(selectedAgency, "TelesalesAgentMedicare");
    //let retailStoreEntitlement = this.agencyHelper.hasEntitlement(selectedAgency, "RetailStore");

    let planAdvisorURL = '';
    let planAdvisorURL_newToBlue = '';
    let additionalUserInfo = '';

    planAdvisorURL = "/emssvc/x-services/secure/sso/outbound/auto/v1/vendor/PRODUCERTOPLANADVISOR" + region.toUpperCase();
    planAdvisorURL_newToBlue = "/emssvc/x-services/secure/sso/outbound/auto/v1/vendor/PRODUCERTOPLANADVISORNEW" + region.toUpperCase();

    //example: "?retailAgencyId=0GAINT5678&agentId=AGTTSTB&deepLink=https://tenvb.highmarkbcbs.com"
    additionalUserInfo = `?retailAgencyId=${agency_ID}&agentId=${login_ID}&deepLink=${this.agencyHelper.getDeepLink()}`;

    this.planAdvisorRenewalSSOUrl = (planAdvisorURL + additionalUserInfo);
    this.planAdvisorNewToBlueSSOUrl = (planAdvisorURL_newToBlue + additionalUserInfo);
  }

  createPlanAdvisorSSOsNonHM() {
    this.createPlanAdvisorCookieNonHM();
    this.planAdvisorRenewalSSOUrl = this.portalLinkService.getUrl({
      domain: this.brandService.getCurrentBrand().domain,
      path: '/plan-advisor/renewals/dashboard'
    });

    this.planAdvisorNewToBlueSSOUrl = this.portalLinkService.getUrl({
      domain: this.brandService.getCurrentBrand().domain,
      path: '/plan-advisor/new/dashboard'
    });
  }
  
  createPlanAdvisorCookieNonHM() {
    let selectedAgency = this.loginData.userInfo.agencyInfo.selectedAgencies[this.lob];
    //let userType = this.loginData.basicUserInfo.userType;
    const agency_ID = selectedAgency.agencyId || selectedAgency.agencyPartyId || selectedAgency.agentACSId;
    const cookieValue = this.loginData.userId + '_' + this.agencyHelper.padAgencyId(agency_ID);

    /****
     * Name: "emkt_userName"
     * Value: "<login id>_<agency id>"
     * Properties:
     *              Domain: (this allows it to be shared in the new tab)
     *                      "highmarkbcbs.com"          or
     *                      "highmarkblueshield.com"    or
     *                      "highmarkbcbs.com"          or
     *                      "highmarkbcbs.com"          or
     *                      "bluecrossmnonline.com"     or
     *                      etc.
     ****/
    this.cookieService.set('emkt_userName', cookieValue, null, '/', this.brandService.getCurrentBrand().domain, true, 'None');
  }

  agencyIdentifierExists(selectedAgency: BaseAgency) {
    const isHmBrandWithAgencyId = !this.brandService.isNonHmBrand() && selectedAgency.agencyId;
    const isNonHmBrandWithValidAgency = this.brandService.isNonHmBrand() && (selectedAgency.agencyId || selectedAgency.agencyPartyId || selectedAgency.agentACSId);
    return isHmBrandWithAgencyId || isNonHmBrandWithValidAgency;
  }

  checkAgencyAccessList(selectedAgency: BaseAgency) {
    if (this.customData?.includes("ALL_AGENCIES") || this.customData?.includes(selectedAgency.agencyId)) {
      return true;
    }

    return false;
  }
}
